import { Tooltip } from "@mui/material";
import { GridEditInputCell } from "@mui/x-data-grid";
import { ObjectNameIsEqualTo } from "../config.muiDataGrid.ts";

const projects = {
  id: "projects",
  label: "Projects",
  endpoint: "projects",
  columnConfig: [
    {
      field: "name",
      headerName: "Activity Name",
      width: 250,
      description: "Activity Name",
      editable: true,
    },
    {
      field: "activity_status",
      headerName: "Activity Status",
      width: 250,
      description: "Activity Status",
      editable: true,
      renderCell: (params) => {
        const status = params.row.activity_status;
        // Return a custom component or a simple string that combines the name and id
        return status?.name || "";
      },
      valueFormatter: (params) => {
        const status = params.value;
        return status?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "activity_statuses",
        categoriesEndpointResponseKey: "activity_statuses",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "projects",
        entityColumnToUpdate: "activity_status_id",
      },
      filterOperators: [ObjectNameIsEqualTo],
    },
    {
      field: "basin",
      headerName: "Basin",
      width: 250,
      description: "Basin",
      editable: true,
      renderCell: (params) => {
        // Access the task object from params
        const basin = params.row.basin;
        // Return a custom component or a simple string that combines the name and id
        return basin?.name || "";
      },
      valueFormatter: (params) => {
        const basin = params.value;
        return basin?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "basins",
        categoriesEndpointResponseKey: "basins",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "projects",
        entityColumnToUpdate: "basin_id",
      },
      filterOperators: [ObjectNameIsEqualTo],
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
      description: "Project Description",
      editable: true,
      preProcessEditCellProps: (params) => {
        const errorMessage =
          params.props.value?.length > 10000 ? "Limit 10000 characters" : null;
        return { ...params.props, error: errorMessage };
      },
      renderEditCell: (props) => {
        const { error } = props;
        return (
          <Tooltip open={!!error} title={error}>
            <GridEditInputCell {...props} />
          </Tooltip>
        );
      },
    },
    {
      field: "task",
      headerName: "Task",
      width: 250,
      description: "Task",
      editable: true,
      renderCell: (params) => {
        const task = params.row.task;
        return task?.name || "";
      },
      valueFormatter: (params) => {
        const task = params.value;
        return task?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "tasks",
        categoriesEndpointResponseKey: "tasks",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "projects",
        entityColumnToUpdate: "task_id",
      },
    },
    {
      field: "people",
      headerName: "People",
      width: 250,
      description: "People",
      editable: true,
      renderCell: (params) => {
        const people = params.row.people;
        return (
          people
            ?.map(({ person }) => `${person.first_name} ${person.last_name}`)
            .join(", ") || ""
        );
      },
      valueFormatter: (params) => {
        const people = params.value;
        return people
          ?.map(({ person }) => `${person.first_name} ${person.last_name}`)
          .join(", ") || "";
      },
      renderEditCellComponent: "SelectProjectPeople",
    },
    {
      field: "sites",
      headerName: "Sites",
      width: 250,
      description: "Sites",
      editable: true,
      renderCell: (params) => {
        const sites = params.row.sites;
        return (
          sites
            ?.map((site) => `${site.name} (${site.site_number})`)
            .join(", ") || ""
        );
      },
      valueFormatter: (params) => {
        const sites = params.value;
        return sites
          ?.map((site) => site.site_number)
          .join(", ") || "";
      },
      renderEditCellComponent: "SelectProjectSites",
    },
  ],
  hiddenColumns: [
    "id",
    "task_id",
    "activity_id",
    "activity_status_id",
    "basin_id",
  ],
  filterOptions: [
    {
      label: "NGWOS Basin",
      id: "basin",
      multiple: false,
      operator: "ObjectNameIsEqualTo",
    },
    {
      label: "Activity Status",
      id: "activity_status",
      multiple: false,
      operator: "ObjectNameIsEqualTo",
    },
  ],
  chipConfig: {},
  tagConfig: {},
};

export default projects;
